import React from "react";

const facilities = [
  {
    id: 1,
    title: "Golf View Restaurant",
    desc: "Guests can avail facilities at the Golf View Restaurant and enjoy premium dining in a serene atmosphere.",
  },
  {
    id: 2,
    title: "Play Golf with Fair Fee",
    desc: "Guests are welcome to play golf with a fair fee, experiencing the beautifully maintained course.",
  },
  {
    id: 3,
    title: "Guest Room Facilities",
    desc: "Guests can avail guest room facilities for a comfortable and convenient stay within the club premises.",
  },
  {
    id: 4,
    title: "Pro Shop Facilities",
    desc: "Guests can access the Pro Shop facilities for golfing essentials and accessories.",
  },
];

const FacilitiesForGuests = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
      {/* Page Title */}
      <h1 className="text-3xl sm:text-4xl font-bold text-center mb-10 text-green-700">
        Facilities for Guests
      </h1>

      {/* Timeline */}
      <div className="relative max-w-3xl mx-auto border-l border-green-300">
        {facilities.map((facility) => (
          <div key={facility.id} className="mb-10 ml-6">
            {/* Circle marker */}
            <span className="absolute -left-3 flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 bg-green-600 rounded-full ring-4 ring-white text-white text-xs sm:text-sm font-bold">
              {facility.id}
            </span>

            {/* Content Card */}
            <div className="p-4 sm:p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition">
              <h2 className="text-lg sm:text-xl font-semibold text-green-700">
                {facility.title}
              </h2>
              <p className="mt-2 text-sm sm:text-base text-gray-700 leading-relaxed">
                {facility.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FacilitiesForGuests;
